import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from "../../hooks/useTranslations";

const Navbar = () => {

const { t } = useTranslation();

  return (
    <header className="bg-surface shadow-sm border-b border-border sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        {/* Left Side: Logo & Brand */}
        <div className="flex items-center gap-3">
          <img
            src="/images/National-Emblem.png"
            alt="Emblem"
            className="h-9 w-auto drop-shadow-sm"
          />

          <div className="flex flex-col">
            <h1 className="text-xl font-extrabold text-text hidden sm:block tracking-tight leading-none mb-0.5">
              {t("navbar.logo")}
            </h1>

            <h1 className="text-xl font-extrabold text-text sm:hidden tracking-tight leading-tight">
              {t("navbar.logoShort")}
            </h1>

            <span className="text-[10px] font-bold text-text-muted uppercase tracking-wider hidden sm:block">
              {t("navbar.wbgovt")}
            </span>
          </div>
        </div>

        {/* Right Side */}
        <div className="flex items-center gap-2 sm:gap-4">
          {/* Home Button */}
          <NavLink
            to="/"
            className={({ isActive }) =>
              `flex items-center gap-1.5 px-3 py-1.5 rounded-lg transition-colors text-sm font-semibold active:scale-95 ${
                isActive
                  ? 'bg-primary/10 text-primary'
                  : 'text-text-muted hover:text-primary hover:bg-primary/10'
              }`
            }
            title="Home"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M3 10.5L12 3l9 7.5"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M5 9.5V20h14V9.5"
              />
            </svg>

            <span className="hidden sm:inline">{t("navbar.home")}</span>
          </NavLink>

          {/* Settings Button */}
          <NavLink
            to="/settings"
            className={({ isActive }) =>
              `flex items-center gap-1.5 px-3 py-1.5 rounded-lg transition-colors text-sm font-semibold active:scale-95 ${
                isActive
                  ? 'bg-primary/10 text-primary'
                  : 'text-text-muted hover:text-primary hover:bg-primary/10'
              }`
            }
            title="Settings"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.757.426 1.757 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.757-2.924 1.757-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.757-.426-1.757-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
              />
            </svg>

            <span className="hidden sm:inline">{t("navbar.settings")}</span>
          </NavLink>
        </div>
      </div>
    </header>
  );
};

export default Navbar;